import { render, staticRenderFns } from "./CustomizeColumnsModal.vue?vue&type=template&id=4c0b6c63"
import script from "./CustomizeColumnsModal.vue?vue&type=script&lang=js"
export * from "./CustomizeColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports